import GRNRawMaterial from "../pages/Inventory/grnEntryRawMaterial.js";
import AdditionalEntry from "../pages/Inventory/additionalEntry.js";
import PurchaseOrder from "../pages/Inventory/purchaseOrder.js";
import InquiryEntry from "../pages/Inventory/inquiryEntry.js";
import GoodsRegister from "../pages/Inventory/goodsRegister.js";
import AccountGroupMaster from "../pages/Master/accountGroupMaster.js";
import AccountMaster from "../pages/Master/accountMaster.js";
import ColourMaster from "../pages/Master/colourMaster.js";
import DayBookMaster from "../pages/Master/dayBookMaster.js";
import HSNCodes from "../pages/Master/hSNCodes.js";
import ItemCategory from "../pages/Master/itemCategory.js";
import ItemMaster from "../pages/Master/itemMaster.js";
import LabelClaimMaster from "../pages/Master/labelClaimMaster.js";
import MfgLicMaster from "../pages/Master/mfgLicMaster.js";
import packingMaterial from "../pages/Master/packingMaterial.js";
import PackingMaterialSizeMaster from "../pages/Master/packingMaterialSizeMaster.js";
import PartyMaster from "../pages/Master/partyMaster.js";
import PartyWiseNetRateMaster from "../pages/Master/partyWiseNetRateMaster.js";
import PMCategoryMaster from "../pages/Master/pmCategoryMaster.js";
import ProductDetails from "../pages/Master/productDetails.js";
import ProductionPMFormula from "../pages/Master/productionPMFormula.js";
import ProductionStage from "../pages/Master/productionStage.js";
import PunchSizeMaster from "../pages/Master/punchSizeMaster.js";
import rawMaterial from "../pages/Master/rawMaterial.js";
import RMCategoryMaster from "../pages/Master/rmCategoryMaster.js";
import RMFormula from "../pages/Master/rmFormula.js";
import Statemaster from "../pages/Master/stateMaster.js";
import StereoMaster from "../pages/Master/stereoMaster.js";
import StorageCondition from "../pages/Master/storageCondition.js";
import TransportCourierMaster from "../pages/Master/transportCourierMaster.js";
import MaterialWisePurchaseReport from "../pages/Inventory/materialWisePurchaseReport.js";
import StockLedgerAndStatement from "../pages/Inventory/stockLedgerAndStatement.js";
import ShortageReport from "../pages/Inventory/shortageReport.js";
import NearExpiryReport from "../pages/Inventory/nearExpiryReport.js";
import PurchaseOrderRegister from "../pages/Inventory/purchseOrderRegister.js";
import PendingPurchaseReport from "../pages/Inventory/pendingPurchaseReport.js";
import Dashboard from "../pages/Home/dashboard.js";
import ProductionPlanningEntry from "../pages/Production/productionPlanningEntry.js";
import ProductionRequisition from "../pages/Production/productionRequisition.js";
import CoatingRequisition from "../pages/Production/coatingRequisition.js";
import PackingRequisition from "../pages/Production/packingRequisition.js";
import BatchClearingEntry from "../pages/Production/batchClearingEntry.js";
import FinishProductLabelPrinting from "../pages/Production/finishProductLabelPrinting.js";
import FinishProductInquiry from "../pages/Production/finishProductInquiry.js";
import QuotationEntry from "../pages/Production/quotationEntry.js";
import SaveCostSheetView from "../pages/Production/saveCostSheetView.js";
import BatchCostingReport from "../pages/Production/batchCostingReport.js";
import ProductCostingReport from "../pages/Production/productCostingReport.js";
import JobChargesReport from "../pages/Production/jobChargesReport.js";
import ProductionBatchRegister from "../pages/Production/productionBatchRegister.js";
import WeighingSlipPrint from "../pages/Production/weighingSlipPrint.js";
import PackingRequisitionPrint from "../pages/Production/packingRequisitionPrint.js";
import ProductionRequisitionPrint from "../pages/Production/productionRequisitionPrint.js";
import PendingProductionPlanningReport from "../pages/Production/pendingProductionPlanningReport.js";
import MaterialRequirmentReportRM from "../pages/Production/materialRequirmentReportRM.js";
import MaterialRequirmentReportPM from "../pages/Production/materialRequirmentReportPM.js";
import GSTInvoiceFinishGoods from "../pages/Despatch/gstInvoiceFinishGoods.js";
import PartyWiseDespatch from "../pages/Despatch/partyWiseDespatch.js";
import GSTInvoicePM from "../pages/Despatch/gSTInvoicePM.js";
import GSTInvoiceRM from "../pages/Despatch/gSTInvoiceRM.js";
import SalesOrderEntry from "../pages/Despatch/salesOrderEntry.js";
import SalesGoodsReturnEntry from "../pages/Despatch/salesGoodsReturnEntry.js";
import InwardPostEntry from "../pages/Despatch/inwardPostEntry.js";
import OutwardPostEntry from "../pages/Despatch/outwardPostEntry.js";
import EnvelopePrint from "../pages/Despatch/envelopePrint.js";
import ItemWiseDespatch from "../pages/Despatch/itemWiseDespatch.js";
import PartyWiseMonthlySales from "../pages/Despatch/partyWiseMonthlySales.js";
import ItemWiseMonthlySales from "../pages/Despatch/itemWiseMonthlySales.js";
import InwardOutwardPostRegister from "../pages/Despatch/inwardOutwardPostRegister.js";
import StockStatementReport from "../pages/Despatch/stockStatementReport.js";
import StockLedgerReport from "../pages/Despatch/stockLedgerReport.js";
import NearExpiryStockReport from "../pages/Despatch/nearExpiryStockReport.js";
import ReceiptEntry from "../pages/Account/receiptEntry.js";
import PaymentEntry from "../pages/Account/paymentEntry.js";
import ContraEntry from "../pages/Account/contraEntry.js";
import GstPurchaseEntryRMPM from "../pages/Account/gstPurchaseEntryRMPM.js";
import GstPurchaseEntryWithoutInventory from "../pages/Account/gstPurchaseEntrywWthoutInventrory.js";
import GeneralCreditNoteEntry from "../pages/Account/generalCreditNoteEntry.js";
import ExpanseEntry from "../pages/Account/expanseEntry.js";
import PartyOutStandingAdjustment from "../pages/Account/partyOutStandingAdjustment.js";
import GstSalesRegister from "../pages/Account/gstSalesRegister.js";
import GstPurchaseRegister from "../pages/Account/gstPurchaseRegister.js";
import GstrOneGenerate from "../pages/Account/gstrOneGenerate.js";
import GstCalculation from "../pages/Account/gstCalculation.js";
import JVEntry from "../pages/Account/JVEntry.js";
import GeneralDebitNoteEntry from "../pages/Account/GeneralDebitNoteEntry.js";
import AccountLedger from "../pages/Account/accountLedger.js";
import CashBankBook from "../pages/Account/cashBankBook.js";
import GroupWiseAccountSummary from "../pages/Account/groupWiseAccountSummary.js";
import PartyWiseOutStandingReport from "../pages/Account/partyWiseOutStandingReport.js";
import PartyWiseOutStandingLetter from "../pages/Account/partyWiseOutStandingLetter.js";
import OpeningBalanceReport from "../pages/Account/openingBalanceReport.js";
import StockCreditEntry from "../pages/Trade/stockCreditEntry.js";
import UserProfile from "../pages/Utility/userProfile.js";
import AdminRole from "../pages/Utility/adminRole.js";
import UserLog from "../pages/Utility/userLog.js";
import OtherDeliveryChallan from "../pages/Despatch/otherDeliveryChallan.js";
import TransactionReport from "../pages/Account/transactionReport.js";
import TestMaster from "../pages/Master/testMaster.js";
import QCMonogramRawMaterial from "../pages/Master/qcMonogramRawMaterial.js";
import QCMonogramPackingMaterial from "../pages/Master/qcMonogramPackingMaterial.js";
import QCMonogramFinishProduct from "../pages/Master/qcMonogramFinishProduct.js";
import FinishProductTestReportEntry from "../pages/QC/finishProductTestReportEntry.js";
import PackingMaterialTestReportEntry from "../pages/QC/packingMaterialTestReportEntry.js";
import RawMaterialTestReportEntry from "../pages/QC/rawMaterialTestReportEntry.js";
import FinishProductSampleEntry from "../pages/QC/finishProductSampleEntry.js";
import PackingMaterialSampleEntry from "../pages/QC/packingMaterialSampleEntry.js";
import RawMaterialSampleEntry from "../pages/QC/rawMaterialSampleEntry.js";
import RawMaterialSampleEntryDetails from "../components/qc/sampleFields/RawMaterialSampleEntryDetails.js";
import PackingMaterialSampleEntryDetails from "../components/qc/sampleFields/PackingMaterialSampleEntryDetails.js";
import FinishProductsSampleEntryDetails from "../components/qc/sampleFields/FinishProductsSampleEntryDetails.js";
import RawMaterialTestEntryDetails from "../components/qc/testReportFields/RawMaterialTestEntryDetails.js";
import PackingMaterialTestEntryDetails from "../components/qc/testReportFields/PackingMaterialTestEntryDetails.js";
import FinishProductTestEntryDetails from "../components/qc/testReportFields/FinishProductTestEntryDetails.js";

const ComponentNavigation = [
  {
    path: "Dashboard",
    title: "Dashboard",
    component: Dashboard,
    hasParams: false,
    roles: [1, 2, 3],
  },
  // {
  //   path: "Login",
  //   title: "Login",
  //   component: Login,
  //   hasParams: false,
  //   roles: [1,2]
  // },

  // Master Navigations Start
  {
    path: "ItemMaster",
    title: "Item Master",
    component: ItemMaster,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "ItemCategory",
    title: "Item Category",
    component: ItemCategory,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "HSNCodes",
    title: "HSN Codes",
    component: HSNCodes,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "RawMaterial",
    title: "Raw Material",
    component: rawMaterial,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "PackingMaterial",
    title: "Packing Material",
    component: packingMaterial,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "RMCategoryMaster",
    title: "R.M. Category Master",
    component: RMCategoryMaster,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "PMCategoryMaster",
    title: "P.M. Category Master",
    component: PMCategoryMaster,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "PartyMaster",
    title: "Party Master",
    component: PartyMaster,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "ProductDetails",
    title: "Product Details",
    component: ProductDetails,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "PackingMaterialSizeMaster",
    title: "Packing Material Size Master",
    component: PackingMaterialSizeMaster,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "StateMaster",
    title: "State Master",
    component: Statemaster,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "StereoMaster",
    title: "Stereo Master",
    component: StereoMaster,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "LabelClaimMaster",
    title: "Label Claim",
    component: LabelClaimMaster,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "ColourMaster",
    title: "Colour Master",
    component: ColourMaster,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "MfgLicMaster",
    title: "Mfg. Lic. Master",
    component: MfgLicMaster,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "StorageCondition",
    title: "Storage Condition",
    component: StorageCondition,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "ProductionStage",
    title: "Production Stagee",
    component: ProductionStage,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "Transport",
    title: "Transport/Courier Master",
    component: TransportCourierMaster,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "TestMaster",
    title: "Test Master",
    component: TestMaster,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "QCMonogramRawMaterial",
    title: "QC Monogram Raw Material",
    component: QCMonogramRawMaterial,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "QCMonogramPackingMaterial",
    title: "QC Monogram Packing Material",
    component: QCMonogramPackingMaterial,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "QCMonogramFinishProduct",
    title: "QC Monogram Finish Product",
    component: QCMonogramFinishProduct,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "RMFormula",
    title: "RM Formula",
    component: RMFormula,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "ProductionPMFormula",
    title: "Production PM Formula",
    component: ProductionPMFormula,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "AccountMaster",
    title: "Account Master",
    component: AccountMaster,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "AccountGroupMaster",
    title: "Account Group Master",
    component: AccountGroupMaster,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "DayBookMaster",
    title: "Day Book Master",
    component: DayBookMaster,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "PartyWiseNetRateMaster",
    title: "Part Wise Net Rate Master",
    component: PartyWiseNetRateMaster,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "PunchSizeMaster",
    title: "Punch Size",
    component: PunchSizeMaster,
    hasParams: false,
    roles: [1, 2],
  },

  // Master Navigations End

  // Inventory Navigations Start
  {
    path: "MaterialGRNEntry",
    title: "G.R.N Entry Raw Material",
    component: GRNRawMaterial,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "AdditionalEntry",
    title: "Additional Entry",
    component: AdditionalEntry,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "InquiryEntry",
    title: "Inquiry Entry",
    component: InquiryEntry,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "PurchaseOrder",
    title: "Purchase Order",
    component: PurchaseOrder,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "GoodsRegister",
    title: "Goods Register",
    component: GoodsRegister,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "MaterialWisePurchaseReport",
    title: "Material Wise Purchase Report",
    component: MaterialWisePurchaseReport,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "StockLedgerAndStatement",
    title: "Stock Ledger And Statement",
    component: StockLedgerAndStatement,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "ShortageReport",
    title: "Shourtage Report",
    component: ShortageReport,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "NearExpiryReport",
    title: "Near Expiry Report",
    component: NearExpiryReport,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "PurchseOrderRegister",
    title: "Purchase Order Register",
    component: PurchaseOrderRegister,
    hasParams: false,
    roles: [1, 2],
  },
  {
    path: "PendingPurchaseReport",
    title: "Pending Purchase Order Register",
    component: PendingPurchaseReport,
    hasParams: false,
    roles: [1, 2],
  },
  // Inventory Navigations End

  // Production Navigation Start
  {
    path: "ProductionPlanningEntry",
    title: "Production Planning Entry",
    component: ProductionPlanningEntry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "ProductionRequisition",
    title: "Production Requisition",
    component: ProductionRequisition,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "CoatingRequisition",
    title: "Coating Requisition",
    component: CoatingRequisition,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "PackingRequisition",
    title: "Packing Requisition",
    component: PackingRequisition,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "BatchClearingEntry",
    title: "Batch Clearing Entry",
    component: BatchClearingEntry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "FinishProductLabelPrinting",
    title: "Finish Product Label Printing",
    component: FinishProductLabelPrinting,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "FinishProductInquiry",
    title: "Finish Product Inquiry",
    component: FinishProductInquiry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "QuotationEntry",
    title: "Quotation Entry",
    component: QuotationEntry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "SaveCostSheetView",
    title: "Save Cost Sheet View",
    component: SaveCostSheetView,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "BatchCostingReport",
    title: "Batch Costing Report",
    component: BatchCostingReport,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "ProductCostingReport",
    title: "Product Costing Report",
    component: ProductCostingReport,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "JobChargesReport",
    title: "Job Charges Report",
    component: JobChargesReport,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "ProductionBatchRegister",
    title: "Production Batch Register",
    component: ProductionBatchRegister,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "WeighingSlipPrint",
    title: "Weighing Slip Print",
    component: WeighingSlipPrint,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "PackingRequisitionPrint",
    title: "Packing Requisition Print",
    component: PackingRequisitionPrint,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "ProductionRequisitionPrint",
    title: "Production Requisition Print",
    component: ProductionRequisitionPrint,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "PendingProductionPlanningReport",
    title: "Pending Production Planning Report",
    component: PendingProductionPlanningReport,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "MaterialRequirmentReportRM",
    title: "Material Requirment Report [RM]",
    component: MaterialRequirmentReportRM,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "MaterialRequirmentReportPM",
    title: "Material Requirment Report [PM]",
    component: MaterialRequirmentReportPM,
    hasParams: false,
    roles: [1, 3],
  },
  // Production Navigation End

  // QC Navigation Start
  {
    path: "RawMaterialSampleEntry",
    title: "Raw Material Sample Entry",
    component: RawMaterialSampleEntry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "RawMaterialSampleEntryDetails",
    title: "Raw Material Sample Entry",
    component: RawMaterialSampleEntryDetails,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "PackingMaterialSampleEntry",
    title: "Packing Material Sample Entry",
    component: PackingMaterialSampleEntry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "PackingMaterialSampleEntryDetails",
    title: "Packing Material Sample Entry",
    component: PackingMaterialSampleEntryDetails,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "FinishProductSampleEntry",
    title: "Finish Product Sample Entry",
    component: FinishProductSampleEntry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "FinishProductSampleEntryDetails",
    title: "Finish Products Sample Entry",
    component: FinishProductsSampleEntryDetails,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "RawMaterialTestReportEntry",
    title: "Raw Material Test Report Entry",
    component: RawMaterialTestReportEntry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "RawMaterialTestReportEntryDetails",
    title: "Raw Material Test Report Entry Details",
    component: RawMaterialTestEntryDetails,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "PackingMaterialTestReportEntry",
    title: "Packing Material Test Report Entry",
    component: PackingMaterialTestReportEntry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "PackingMaterialTestReportEntryDetails",
    title: "Packing Material Test Report Entry Details",
    component: PackingMaterialTestEntryDetails,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "FinishProductTestReportEntry",
    title: "Finish Product Test Report Entry",
    component: FinishProductTestReportEntry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "FinishProductTestReportEntryDetails",
    title: "Finish Product Test Report Entry Details",
    component: FinishProductTestEntryDetails,
    hasParams: false,
    roles: [1, 3],
  },
  // QC Navigation End

  // Despatch Navigation Start
  {
    path: "GSTInvoiceFinishGoods",
    title: "GST Invoice Finish Goods",
    component: GSTInvoiceFinishGoods,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "GSTInvoiceRM",
    title: "GST Invoice RM",
    component: GSTInvoiceRM,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "GSTInvoicePM",
    title: "GST Invoice PM",
    component: GSTInvoicePM,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "SalesOrderEntry",
    title: "Sales Order Entry",
    component: SalesOrderEntry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "SalesGoodsReturnEntry",
    title: "Sales Goods Return Entry",
    component: SalesGoodsReturnEntry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "OtherDeliveryChallan",
    title: "Other Delivery Challan",
    component: OtherDeliveryChallan,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "InwardPostEntry",
    title: "Inward Post Entry",
    component: InwardPostEntry,
    hasParams: false,
    roles: [1, 3],
  },

  {
    path: "OutwardPostEntry",
    title: "Outward Post Entry",
    component: OutwardPostEntry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "EnvelopePrint",
    title: "Outward Post Entry",
    component: EnvelopePrint,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "PartyWiseDespatch",
    title: "Party Wise Despatch",
    component: PartyWiseDespatch,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "ItemWiseDespatch",
    title: "Item Wise Despatch",
    component: ItemWiseDespatch,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "PartyWiseMonthlySales",
    title: "Party Wise Monthly Sales",
    component: PartyWiseMonthlySales,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "ItemWiseMonthlySales",
    title: "Item Wise Monthly Sales",
    component: ItemWiseMonthlySales,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "InwardOutwardPostRegister",
    title: "Inward Outward Post Register",
    component: InwardOutwardPostRegister,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "StockStatementReport",
    title: "Stock Statement Report",
    component: StockStatementReport,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "StockLedgerReport",
    title: "Stock Ledger Report",
    component: StockLedgerReport,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "NearExpiryStockReport",
    title: "Near Expiry Stock Report",
    component: NearExpiryStockReport,
    hasParams: false,
    roles: [1, 3],
  },
  // Despatch Navigation End


  // Account Navigation Start
  {
    path: "ReceiptEntry",
    title: "Receipt Entry",
    component: ReceiptEntry,
    hasParams: false,
    roles: [1, 3],
  }, {
    path: "PaymentEntry",
    title: "Payment Entry",
    component: PaymentEntry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "ContraEntry",
    title: "Contra Entry",
    component: ContraEntry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "GstPurchaseEntryRMPM",
    title: "GST Purchase Entry [RM/PM]",
    component: GstPurchaseEntryRMPM,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "GstPurchaseEntryWithoutInventory",
    title: "GST Purchase Entry [W/o Inventory]",
    component: GstPurchaseEntryWithoutInventory,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "GeneralDebitNoteEntry",
    title: "General Debit Note Entry [GST]",
    component: GeneralDebitNoteEntry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "GeneralCreditNoteEntry",
    title: "General Credit Note Entry [GST]",
    component: GeneralCreditNoteEntry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "ExpanseEntry",
    title: "Expanse Entry [GST]",
    component: ExpanseEntry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "JVEntry",
    title: "J.V. Entry",
    component: JVEntry,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "PartyOutStandingAdjustment",
    title: "Party Out-Standing Adjustment",
    component: PartyOutStandingAdjustment,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "GstSalesRegister",
    title: "GST Sales Register",
    component: GstSalesRegister,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "GstPurchaseRegister",
    title: "GST Purchase Register",
    component: GstPurchaseRegister,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "GstrOneGenerate",
    title: "G.S.T.R.-1 Generate",
    component: GstrOneGenerate,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "GstCalculation",
    title: "GST Calculation",
    component: GstCalculation,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "AccountLedger",
    title: "Account Ledger",
    component: AccountLedger,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "TransactionReport",
    title: "Transaction Report",
    component: TransactionReport,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "CashBankBook",
    title: "Cash/Bank Book",
    component: CashBankBook,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "GroupWiseAccountSummary",
    title: "Group Wise Account Summary",
    component: GroupWiseAccountSummary,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "PartyWiseOutStandingReport",
    title: "Party Wise Out-Standing Report",
    component: PartyWiseOutStandingReport,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "PartyWiseOutStandingLetter",
    title: "Party Wise Out-Standing Letter",
    component: PartyWiseOutStandingLetter,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "OpeningBalanceReport",
    title: "Opening Balance Report",
    component: OpeningBalanceReport,
    hasParams: false,
    roles: [1, 3],
  },

  // Trading
  {
    path: "StockCreditEntry",
    title: "Stock Credit Entry",
    component: StockCreditEntry,
    hasParams: false,
    roles: [1, 3],
  },

  // Account Navigation End

  //  Utility Navigation Start
  {
    path: "UserProfile",
    title: "User Profile",
    component: UserProfile,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "AdminRole",
    title: "Admin Role",
    component: AdminRole,
    hasParams: false,
    roles: [1, 3],
  },
  {
    path: "UserLog",
    title: "User Log",
    component: UserLog,
    hasParams: false,
    roles: [1, 3],
  }


];
export default ComponentNavigation;
